
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { DataTableHeader } from 'vuetify';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import paginacion from './lista-listado-paginacion.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            paginacion
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        public get Headers(): Array<DataTableHeader>
        {

            return [
                { text: '', align: 'start', width: 50, value: 'Imagen', },
                { text: 'Fecha', align: 'start', width: 250, value: 'Col1', },
                { text: 'Cuenta', align: 'end', width: 250, value: 'Col2' },
                { text: 'Ventas', align: 'center', value: 'Col3' },
                { text: '% Reclamos', align: 'center', value: 'Col4' },
                { text: '% Canceladas', align: 'center', value: 'Col5' },
                { text: '% Demoras', align: 'center', value: 'Col6' },
            ];

        }
    }
